export default function GroupLogo({ className = '' }) {
  return <img className={`muvo-logo ${className}`} src="/images/logo_muvogroup.png" alt="MuvoGroup" width="400" height="80" loading="lazy" />;
}
